import { render, staticRenderFns } from "./CompPlatformAdminStats.vue?vue&type=template&id=4fe0e05e&scoped=true"
import script from "./CompPlatformAdminStats.vue?vue&type=script&lang=js"
export * from "./CompPlatformAdminStats.vue?vue&type=script&lang=js"
import style0 from "./CompPlatformAdminStats.vue?vue&type=style&index=0&id=4fe0e05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe0e05e",
  null
  
)

export default component.exports